/* @flow */

import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';

import { backToAppPlugin } from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getBackToAppOptions(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[backToAppPlugin];

  if (options) {
    assertObject(options, 'options');

    return options;
  }
}

export function getBackToAppURL(event: BraindateEvent): ?string {
  return (getBackToAppOptions(event) || {}).url;
}

export function getBackToAppLabel(event: BraindateEvent): ?string {
  return (getBackToAppOptions(event) || {}).label;
}

export function getBackToAppIcon(event: BraindateEvent): ?string {
  return (getBackToAppOptions(event) || {}).icon_url;
}
